/**
 * IMPORTS
 */

import { tecnologiasRepository } from "@/repositories/tecnologias";

/**
 * Função que busca dados de tecnologias 🛠️.
 */
const handleGetTecnologias = async (
  accessToken: string,
  currentPage: number,
  itemsPerPage: number,
  searchItem: string,
  somenteAtivos = false
) => {
  try {
    const data = await tecnologiasRepository.getAllTecnologias(
      accessToken,
      currentPage,
      itemsPerPage,
      searchItem,
      somenteAtivos
    );

    return data;
  } catch (error: any) {
    console.log("ERROR EM BUSCAR TECNOLOGIAS: ", error);

    return error;
  }
};

/**
 * EXPORTS
 */
export { handleGetTecnologias };
